import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import moment from 'moment';

import { ToastrService } from 'ngx-toastr';
import { PatientService } from '../../../services/patient.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequisitionBuilderDialogComponent } from '../requisition-builder-dialog/requisition-builder-dialog.component';

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: 'dd/MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd/MM/yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
@Component({
  selector: 'app-patient-onboard-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    provideNativeDateAdapter(APP_DATE_FORMATS)
  ],

  templateUrl: './patient-onboard-dialog.component.html',
  styleUrls: ['./patient-onboard-dialog.component.scss']
})
export class PatientOnboardDialogComponent {

  @Output()
  patientCreated = new EventEmitter<any>();
  @ViewChild('patientListModal')
  patientListModal!: TemplateRef<any>;
  selectedFormValue: any = {

    firstname: '',

    middlename: '',

    lastname: ''

  };
  patientList: any[] = [];
  showSameRMNPopup: boolean = false;
  isOTPConfirmed = false;
  isConfirmLoading = false;

  showPatientList = false;
  todayDate = new Date()
  dob: any = '';

  ageYears: any | null = null;
  ageMonths: any = '';
  isUnderTwoYears: boolean = false;
  ageWeeks: any = '';
  mobileNumber = '';
  secondMobileNumber = '';

  patientAddress = '';
  patientLocality = '';
  selectedPatient: any = null;

  patientCity = '';
  patientPincode = '';

  selectedLanguage = '';

  imageUrlS3 = '';

  showLoading = false;

  selectGender = '';

  showDobField = true;
  showAgeField = true;

  ageWarning = '';

  genderArry = [
    {
      name: 'Male',
      selected: true
    },
    {
      name: 'Female',
      selected: false
    }
  ];

  constructor(
    private patientService: PatientService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PatientOnboardDialogComponent>,

  ) {
    this.selectGender = 'Male';
    console.log(
      'DIALOG REF',
      this.dialogRef
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  selectModalValueGender(index: number): void {

    this.genderArry.forEach(
      item => item.selected = false
    );

    this.genderArry[index].selected = true;

    this.selectGender =
      this.genderArry[index].name;
  }
  confirmPrimaryMobile(): void {

    const mobile =
      (this.mobileNumber || '')
        .replace(/\D/g, '')
        .slice(0, 10);

    if (!mobile) {

      this.toastr.error(
        'Enter mobile number'
      );

      return;
    }


    if (!/^\d{10}$/.test(mobile)) {

      this.toastr.error(
        'Enter valid 10 digit mobile number'
      );

      return;
    }
    this.isConfirmLoading = true;

    this.isOTPConfirmed = false;

    this.selectedPatient = null;
    const postData = {

      contactNo:
        '+91' + mobile

    };


    console.log(
      'CHECK PRIMARY MOBILE:',
      postData
    );
    this.patientService
      .findPatientsByNameDOBNumber(postData)
      .subscribe({

        next: (response: any) => {

          console.log(
            'PRIMARY MOBILE RESPONSE:',
            response
          );
          this.isConfirmLoading = false;

          const patients = this.normalizePatientResponse(
            response
          );
          if (patients.length > 0) {

            this.patientList = patients;


            console.log(
              'EXISTING PATIENT LIST:',
              this.patientList
            );


            // Do NOT confirm yet.
            //
            // User must select an existing patient
            // and click Proceed With Same RMN.

            this.isOTPConfirmed = false;


            this.openPatientList();

            return;
          }


          // =================================================
          // NO EXISTING PATIENT
          // =================================================

          this.patientList = [];

          this.selectedPatient = null;

          this.isOTPConfirmed = true;


          this.toastr.success(
            'Mobile number confirmed'
          );

        },


        error: (error: any) => {

          console.error(
            'PRIMARY MOBILE CHECK ERROR:',
            error
          );


          this.isConfirmLoading = false;

          this.isOTPConfirmed = false;

          this.selectedPatient = null;


          this.toastr.error(
            error?.error?.message ||
            'Unable to check mobile number'
          );

        }

      });

  }

  private normalizePatientResponse(
    response: any
  ): any[] {

    if (!response) {
      return [];
    }


    if (Array.isArray(response)) {

      return response;

    }


    if (Array.isArray(response.data)) {

      return response.data;

    }


    if (response.data) {

      return [response.data];

    }


    return [response];

  }

  proceedWithSameRMN(modal: any): void {

    console.log(
      'Proceeding with same RMN:',
      this.mobileNumber
    );

    modal.close({
      proceedWithSameRMN: true
    });

  }
  modifyRMN(
    modal: any
  ): void {

    console.log(
      'USER SELECTED: MODIFY RMN'
    );
    // Close popup
    modal.dismiss();
    // Previous confirmation is invalid
    this.isOTPConfirmed = false;
    // Clear mobile
    this.mobileNumber = '';
    // Focus mobile input
    setTimeout(() => {
      const input =
        document.querySelector(
          '.primary-mobile-input'
        ) as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 100);
  }

  calculateAge(
    today: Date,
    birthDate: Date
  ): number[] {

    let years =
      today.getFullYear() -
      birthDate.getFullYear();

    let months =
      today.getMonth() -
      birthDate.getMonth();

    let days =
      today.getDate() -
      birthDate.getDate();

    if (days < 0) {
      months--;
      days += 30;
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return [years, months, days];
  }

  getAge(): void {

    if (!this.dob) {
      return;
    }

    const birthDate = new Date(this.dob);
    const today = new Date();

    const age = this.calculateAge(today, birthDate);

    const years = Number(age[0]);

    this.ageMonths = age[1];
    this.ageWeeks = age[2];

    if (years <= 2) {

      this.showDobField = false;
      this.showAgeField = true;

      this.isUnderTwoYears = true;

      this.ageYears = 'Under 2 Years';

    } else {

      this.showDobField = true;
      this.showAgeField = false;

      this.isUnderTwoYears = false;

      this.ageYears = years.toString();
    }
  }

  addAge(): void {

    this.ageWarning = '';

    if (
      this.ageYears === '' ||
      this.ageYears === null ||
      this.ageYears === undefined
    ) {

      this.showDobField = true;
      return;
    }

    const age = Number(this.ageYears);

    if (age <= 2) {

      this.ageWarning =
        'Use DOB for age less than 2 yrs';

      this.showDobField = true;

      this.dob = '';

      this.ageYears = '';

      return;
    }

    this.showDobField = false;
    this.showAgeField = true;

    const currentYear = new Date().getFullYear();

    const birthYear = currentYear - age;

    // 01/01/YYYY
    this.dob = `${birthYear}-01-01`;

    console.log('DOB', this.dob);
  }

  onAgeFieldFocus(): void {

    if (this.isUnderTwoYears) {

      // Clear everything
      this.dob = '';
      this.ageYears = '';

      // Allow manual age entry
      this.isUnderTwoYears = false;

      // Show Age field only
      this.showDobField = true;
      this.showAgeField = true;
    }
  }

  validateNumber(event: KeyboardEvent): boolean {

    const charCode =
      event.which ? event.which : event.keyCode;

    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57)
    ) {
      event.preventDefault();
      return false;
    }

    return true;
  }

  openPatientList(): void {

    if (!this.patientListModal) {

      console.error(
        'patientListModal template not found'
      );

      return;
    }


    const modalRef =
      this.modalService.open(
        this.patientListModal,
        {
          centered: true,

          backdrop: 'static',

          keyboard: false,

          windowClass:
            'same-rmn-ngb-window',

          backdropClass:
            'same-rmn-ngb-backdrop'
        }
      );


    modalRef.result
      .then((result: any) => {

        console.log(
          'SAME RMN MODAL RESULT:',
          result
        );


        // =================================================
        // EXISTING PATIENT SELECTED
        // =================================================

        if (
          result?.proceedWithSameRMN &&
          result?.patient
        ) {

          console.log(
            'EXISTING PATIENT SELECTED:',
            result.patient
          );


          // Existing patient is already valid.
          //
          // We do NOT create a new patient.
          //
          // Instead close Patient Onboarding dialog
          // and send selected patient to parent.

          this.dialogRef.close({

            openRequisition: true,

            patient: result.patient,

            existingPatient: true

          });

        }

      })
      .catch((reason: any) => {

        console.log(
          'Same RMN popup dismissed:',
          reason
        );

      });

  }


  openRequisitionBuilder(
    patient: any
  ): void {

    console.log(
      'OPENING REQUISITION BUILDER',
      patient
    );

    const dialogRef =
      this.dialog.open(
        RequisitionBuilderDialogComponent,
        {
          width: '65vw',
          // maxWidth: '1500px',

          height: '99vh',
          // maxHeight: '92vh',

          panelClass: 'requisition-dialog-panel',

          disableClose: false,
          autoFocus: false,

          data: {
            patient: patient
          }
        }
      );

    dialogRef.afterClosed()
      .subscribe({

        next: (result: any) => {

          console.log(
            'REQUISITION BUILDER CLOSED',
            result
          );

          if (result?.refresh) {

            console.log(
              'REFRESHING REQUISITIONS'
            );

            // this.loadRequisitions();

          }

        },

        error: (error: any) => {

          console.log(
            'DIALOG CLOSE ERROR',
            error
          );

        }

      });

  }

  patientFormOpen(modal?: any): void {

    if (modal) {
      modal.dismiss();
    }

    this.isOTPConfirmed = false;

    this.mobileNumber = '';

  }
  onMobileInput(): void {

    this.mobileNumber =
      (this.mobileNumber || '')
        .replace(/\D/g, '')
        .slice(0, 10);

    // Very important:
    // Changing RMN means previous confirmation is no longer valid
    this.isOTPConfirmed = false;
  }
  onSecondMobileInput(): void {

    this.secondMobileNumber =
      (this.secondMobileNumber || '')
        .replace(/\D/g, '')
        .slice(0, 10);

  }
  onSubmitButtonn(): void {

    const normalizeMobile = (value: any): string => {

      let number = String(value || '')
        .replace(/\D/g, '');

      if (
        number.length === 12 &&
        number.startsWith('91')
      ) {
        number = number.substring(2);
      }

      return number;
    };


    // =========================================================
    // BASIC INFORMATION
    // =========================================================

    const firstName =
      this.selectedFormValue.firstname?.trim() || '';

    const middleName =
      this.selectedFormValue.middlename?.trim() || '';

    const lastName =
      this.selectedFormValue.lastname?.trim() || '';


    // =========================================================
    // MOBILE NUMBERS
    // =========================================================

    const mobile =
      normalizeMobile(this.mobileNumber);

    const secondMobile =
      normalizeMobile(this.secondMobileNumber);


    // =========================================================
    // VALIDATION
    // =========================================================

    if (!firstName) {

      this.toastr.error('Enter first name');

      return;
    }


    if (!lastName) {

      this.toastr.error('Enter last name');

      return;
    }


    if (!mobile) {

      this.toastr.error('Enter mobile number');

      return;
    }


    if (!/^\d{10}$/.test(mobile)) {

      this.toastr.error(
        'Enter valid 10 digit mobile number'
      );

      return;
    }


    // Secondary mobile is optional

    if (
      secondMobile &&
      !/^\d{10}$/.test(secondMobile)
    ) {

      this.toastr.error(
        'Enter valid second mobile number'
      );

      return;
    }


    if (!this.selectGender) {

      this.toastr.error('Select gender');

      return;
    }


    if (
      !this.dob &&
      !this.ageYears
    ) {

      this.toastr.error(
        'Enter DOB or Age'
      );

      return;
    }


    // =========================================================
    // FORMAT MOBILE NUMBERS
    // =========================================================

    const formattedMobile =
      `+91 ${mobile}`;

    const formattedSecondMobile =
      secondMobile
        ? `+91 ${secondMobile}`
        : '';


    // =========================================================
    // DOB
    // =========================================================

    let formattedDob = '';


    if (this.dob) {

      const dobMoment =
        moment(this.dob);

      if (!dobMoment.isValid()) {

        this.toastr.error(
          'Please select a valid date of birth'
        );

        return;
      }

      formattedDob =
        dobMoment.format('DD-MMM-YYYY');

    }

    else if (this.ageYears) {

      const enteredAge =
        Number(this.ageYears);


      if (
        !Number.isInteger(enteredAge) ||
        enteredAge < 0
      ) {

        this.toastr.error(
          'Enter valid age'
        );

        return;
      }


      if (enteredAge <= 2) {

        this.toastr.error(
          'Please use DOB for age less than 2 yrs'
        );

        return;
      }


      formattedDob =
        moment()
          .subtract(
            enteredAge,
            'years'
          )
          .format('DD-MMM-YYYY');

    }


    // =========================================================
    // CALCULATE AGE
    // =========================================================

    const age =
      moment().diff(
        moment(
          formattedDob,
          'DD-MMM-YYYY'
        ),
        'years'
      );


    // =========================================================
    // PATIENT TYPES
    // =========================================================

    const patientTypes: string[] =
      age < 12
        ? ['Ba', 'Pe']
        : ['Ba'];


    // =========================================================
    // VISIT
    // =========================================================

    const visit: any =
      age < 12
        ? {
          weight: '',
          height: 0,
          hc: 0,
          cc: 0,
          bpSys: 0,
          bpDia: 0,
          addedBy: 'lab'
        }
        : [];


    // =========================================================
    // POST DATA
    // =========================================================

    const postData = {

      // Contact
      contactNo:
        formattedMobile,

      spouseContactNo:
        formattedSecondMobile,


      // Basic Information
      firstName:
        firstName,

      middleName:
        middleName,

      lastName:
        lastName,

      gender:
        this.selectGender,


      // DOB
      DOB:
        formattedDob,

      eDOB:
        formattedDob,


      // Profile
      profilePic:
        this.imageUrlS3 || '',


      // Address
      address:
        this.patientAddress?.trim() || '',

      locality:
        this.patientLocality?.trim() || '',

      city:
        this.patientCity?.trim() || '',

      pincode:
        this.patientPincode?.trim() || '',


      // Language
      selectedLanguage:
        this.selectedLanguage || '',


      // Other
      vaccinationStartDate:
        moment(
          formattedDob,
          'DD-MMM-YYYY'
        ).format('YYYY-MM-DD'),

      isHighRisk:
        '',


      // Patient Types
      patientTypes:
        patientTypes,


      // Visit
      visit:
        visit

    };


    // =========================================================
    // DEBUG
    // =========================================================

    console.log(
      'PATIENT ONBOARD POST DATA:',
      JSON.stringify(
        postData,
        null,
        2
      )
    );


    // =========================================================
    // LOADING
    // =========================================================

    this.showLoading = true;


    // =========================================================
    // API
    // =========================================================

    this.patientService
      .addNewPatient(postData)
      .subscribe({

        // =====================================================
        // SUCCESS
        // =====================================================

        next: (response: any) => {

          console.log(
            'ONBOARD RESPONSE:',
            response
          );


          console.log(
            'REQUEST SECONDARY:',
            postData.spouseContactNo
          );

          console.log(
            'RESPONSE SECONDARY:',
            response?.data?.spouseContactNo ||
            response?.spouseContactNo
          );


          this.showLoading = false;


          // Success message

          this.toastr.success(
            'Patient created successfully'
          );
          this.resetPatientForm();

          // Notify parent

          this.patientCreated.emit(
            response
          );


          // Close dialog and open requisition

          this.dialogRef.close({

            openRequisition:
              true,

            patient:
              response?.data ||
              response

          });

        },


        // =====================================================
        // ERROR
        // =====================================================

        error: (error: any) => {

          console.error(
            'PATIENT CREATION ERROR:',
            error
          );


          this.showLoading = false;


          this.toastr.error(

            error?.error?.message ||
            error?.message ||
            'Unable to create patient'

          );

        }

      });

  }
  resetPatientForm(): void {

    this.selectedFormValue = {

      firstname: '',

      middlename: '',

      lastname: ''

    };


    this.mobileNumber = '';

    this.secondMobileNumber = '';


    this.patientAddress = '';

    this.patientLocality = '';

    this.patientCity = '';

    this.patientPincode = '';


    this.selectedLanguage = '';


    this.dob = '';

    this.ageYears = '';


    this.selectGender = 'Male';


    this.genderArry.forEach(
      (g, index) =>
        g.selected = index === 0
    );


    this.showLoading = false;

  }
  close() {
    this.dialogRef.close();
  }
}